import React from "react"
import Layout from "../components/layout"
import PubliList from "../components/publiArticle"
import { Container } from "react-bootstrap"
import PubliReview from "../components/publiReview"

export default function PublicationPage() {

  return (
    <Layout>
        <Container className="sectionPeople">
          <h1 className="pub2Title">Research Articles</h1>
          <PubliList/>
        <h1 className="pub2Title" style={{paddingTop: "50px"}}>Reviews</h1>

        <PubliReview/>
      </Container>


    </Layout>
  )
}
